import { apiRequest } from "./common";

const getConversationList = async () => {
    const response = await apiRequest('get', `/chat/conversations`);
    return response.data;
};

const joinConversation = async (data) => {
    const response = await apiRequest('post', `/chat/join-conversation`, data);
    return response.data;
};

const sendMessage = async (data) => {
    const response = await apiRequest('post', `/chat/send-file`, data);
    return response.data;
};

const getMessages = async (conversationId, pageNo, pageSize) => {
    const response = await apiRequest('get', `/chat/messages/${conversationId}?page=${pageNo}&limit=${pageSize}`);
    return response.data;
};

const markRead = async (data) => {
    const response = await apiRequest('post', `/chat/read`, data);
    return response.data;
};

export {
    getConversationList,
    joinConversation,
    sendMessage,
    getMessages,
    markRead
}